import { tenants } from "../../config/tenants.js";
import type { Locale, LocalizedString } from "../Locale.js";

export function getPathInLocale(locale: Locale, path: string | Partial<LocalizedString>): string {
	return [tenants[locale].path, typeof path === "object" ? path[locale] : path].filter(Boolean).join("/");
}
